import { defineComponent as _defineComponent } from 'vue'
import { BaseText, Heading } from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/MoneyV2';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  head?: string;
  title?: string;
  subtitle?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ChartSummary',
  props: {
    head: null,
    title: null,
    subtitle: null
  },
  setup(__props: any) {



return { __sfc: true,BaseText, Heading, Money, NebraskaColors }
}

})